import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-pop-in.tsx
/**
* icon.24.pop.in
*
* Keywords: external, arrow, outward, square, diagonal, share, link, open
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkuNSA2YS41LjUgMCAwIDEgMCAxaC0yYS41LjUgMCAwIDAtLjUuNXY5YS41LjUgMCAwIDAgLjUuNWg5YS41LjUgMCAwIDAgLjUtLjV2LTJhLjUuNSAwIDAgMSAxIDB2MmExLjUgMS41IDAgMCAxLTEuNSAxLjVoLTlBMS41IDEuNSAwIDAgMSA2IDE2LjV2LTlBMS41IDEuNSAwIDAgMSA3LjUgNnptNy42NDcuMTQ3YS41LjUgMCAxIDEgLjcwNy43MDdMMTMuNzA3IDExSDE3LjVhLjUuNSAwIDAgMSAwIDFoLTVhLjUuNSAwIDAgMS0uNS0uNXYtNWEuNS41IDAgMCAxIDEgMHYzLjc5M3oiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=19901-7929
*/
const Icon24PopIn = memo(function Icon24PopIn(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M9.5 6a.5.5 0 0 1 0 1h-2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6zm7.647.147a.5.5 0 1 1 .707.707L13.707 11H17.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v3.793z"
		})
	});
});
//#endregion
export { Icon24PopIn };

//# sourceMappingURL=icon-24-pop-in.js.map